var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.tableData,
              option: _vm.tableOption,
              page: _vm.page,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshChange,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _vm.permissionList.addBtn
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-upload", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.access(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t接入\n\t\t\t\t")]
                        )
                      : _vm._e(),
                    _vm.permissionList.addBtn
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-check", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.generateQr(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t二维码\n\t\t\t\t")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogFormVisible, title: "接入" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [_vm._v("服务器地址(URL)")]),
              _c("el-col", { attrs: { id: "target", span: 12 } }, [
                _vm._v(_vm._s(_vm.wxurl)),
              ]),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { id: "btn", type: "primary" },
                      on: { click: _vm.copyLink },
                    },
                    [_vm._v("点击复制")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }